import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RoomType } from '@lib/state';
import { MenuItem } from '@material-ui/core';
import { FormTextField } from '../../forms';
import React from 'react';

interface Props {
  selectedRoomTypeId: string;
  roomTypes: Array<RoomType>;
  setRoomType: (roomTypeId: string) => void;
  className?: string;
  iconColor?: string;
  placeholder?: string;
  error: boolean;
}

export function RoomTypeSelectForm({
  selectedRoomTypeId,
  roomTypes,
  setRoomType,
  className,
  iconColor,
  placeholder,
  error,
}: Props) {
  return (
    <FormTextField
      className={className}
      color="primary"
      label="Room Type"
      name="roomTypeId"
      value={selectedRoomTypeId ?? ''}
      onChange={e => setRoomType(e.target.value as string)}
      data-testid="locationFormRoomTypeSelect"
      disabled={roomTypes.length === 0}
      select
      SelectProps={{
        displayEmpty: !!placeholder,
        IconComponent: (props: any) => (
          <FontAwesomeIcon
            icon="chevron-down"
            transform="down-6 left-4"
            color={iconColor}
            fixedWidth
            {...props}
          />
        ),
      }}
      size="small"
      fullWidth
      controlled
      error={error}
    >
      {placeholder && (
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
      )}
      {roomTypes.map(x => (
        <MenuItem key={x.id} value={x.id}>
          {x.name}
        </MenuItem>
      ))}
    </FormTextField>
  );
}
